"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelHelpInfoPopover = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const NotificationInfoOutlineIcon_1 = require("@tableau/icons/NotificationInfoOutlineIcon");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelStyles_1 = require("../LabelStyles");
const LabelHelpTooltips_1 = require("./LabelHelpTooltips");
const LabelHelpUrl_1 = require("./LabelHelpUrl");
function LabelHelpInfoPopover({ dialogType, labelValueName }) {
    const popoverInstance = react_1.default.useRef(null);
    const helpNoteForLabelValue = useHelpNoteForLabelValue(labelValueName);
    const helpNoteFallback = useHelpNote(dialogType);
    return (react_1.default.createElement("div", { style: LabelStyles_1.LabelStyles.infoIconStyle },
        react_1.default.createElement(widgets_1.PopoverWidget, { popoverContent: react_1.default.createElement(LabelHelpTooltips_1.HelpTextDiv, null, helpNoteForLabelValue !== null && helpNoteForLabelValue !== void 0 ? helpNoteForLabelValue : helpNoteFallback,
                react_1.default.createElement(LabelHelpUrl_1.LabelHelpUrl, { dialogType: dialogType })), ref: popoverInstance, title: catalog_messages_1.Messages.labelDialogPopoverAltText(), triggerElement: react_1.default.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Icon },
                react_1.default.createElement(NotificationInfoOutlineIcon_1.NotificationInfoOutlineIcon, { size: LabelStyles_1.LabelStyles.INFO_ICON_SIZE, alt: catalog_messages_1.Messages.labelDialogInfoIconAltText() })), placement: 'bottom-start', width: LabelStyles_1.LabelStyles.POPOVER_WIDTH })));
}
exports.LabelHelpInfoPopover = LabelHelpInfoPopover;
function useHelpNoteForLabelValue(labelValueName) {
    switch (labelValueName) {
        case 'CERTIFIED':
            return catalog_messages_1.Messages.certificationLabelValueHelpNote();
        case 'FLOW_RUN_FAILURE':
            return catalog_messages_1.Messages.dataQualityTrigger_flowRunFailure_HelpNote();
        case 'EXTRACT_REFRESH_FAILURE':
            return catalog_messages_1.Messages.dataQualityTrigger_extractRefreshFailure_HelpNote();
        default: {
            return null;
        }
    }
}
function useHelpNote(dialogType) {
    switch (dialogType) {
        case 'certification':
            return catalog_messages_1.Messages.certificationHelpNoteCustom();
        case 'sensitivity':
            return catalog_messages_1.Messages.sensitiveDataLabelHelpNote();
        case 'EXTRACT_REFRESH_FAILURE':
            return catalog_messages_1.Messages.dataQualityTriggerDialog_Datasource_HelpNote();
        case 'FLOW_RUN_FAILURE':
            return catalog_messages_1.Messages.dataQualityTriggerDialog_Flow_HelpNote();
        case 'warning':
            return catalog_messages_1.Messages.dataQualityDialog_v2_HelpCustom();
        default:
            return null;
    }
}
//# sourceMappingURL=LabelHelpInfoPopover.js.map